import {ConfigService, ErrorsService, Poi, ModelsList, StoreService} from 'shared';
import {Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {map} from 'leaflet';

@Injectable({
  deps: [HttpClient],
  providedIn: 'root'
})
export class PoiService extends StoreService<Poi> {

  constructor(http: HttpClient, config: ConfigService, errors: ErrorsService) {
    super(http, config, errors);
    this.initStore(Poi);
  }

  protected load(queryParams?: HttpParams): Observable<ModelsList<Poi>> {
    return this.http.get<ModelsList<Poi>>(this.config.apiVerUrl('/app/poi'), {params: queryParams});
  }

  protected insert(values: Poi): Observable<number> {
    return this.http.post<number>(this.config.apiVerUrl('/app/poi'), values);
  }

  protected remove(id): Observable<void> {
    return this.http.delete<void>(this.config.apiVerUrl(`/app/poi/${id}`));
  }

  update(id, values: Poi): Observable<Poi> {
    return this.http.put<Poi>(this.config.apiVerUrl(`/app/poi/${id}`), values);
  }

}
